const TransferTimeCalculations = ({ storageResult, storageUnits, interfaceType, speedUnits }) => {
  if (storageResult !== 0 && interfaceType.value !== 0) {
    let transferTimeInSeconds = (storageResult * 8 * storageUnits.factor) / (interfaceType.value * speedUnits.factor);
    let transferTimeInSecondsRound = parseFloat(transferTimeInSeconds).toFixed(2);

    if (transferTimeInSecondsRound < 60) {
      return { days: 0, hours: 0, minutes: 1 };
    }

    let durationInDays = parseInt(transferTimeInSecondsRound / (24 * 60 * 60));
    let durationInHours = parseInt((transferTimeInSecondsRound % (24 * 60 * 60)) / (60 * 60));
    let durationInMinutes = parseInt(((transferTimeInSecondsRound % (24 * 60 * 60)) % (60 * 60)) / 60);

    return { days: durationInDays, hours: durationInHours, minutes: durationInMinutes };
  }
  return { days: 0, hours: 0, minutes: 0 };
};

export default TransferTimeCalculations;
